<template>
  <div class="sidemenu">
    <div class="sysTitle">
      <!-- {{ roleId === 1 ? '代理商' :'商户' }} -->
      <div class="marg" v-if='roleId===1'>智掌柜代理商管理系统</div>
      <div class="marg" v-else>智掌柜商户管理后台</div>
    </div>
    <ul
      class="menu-ul"
      @click="tab"
    >
      <li
        v-for="(route,index) of routes"
        :key="index"
        class="menu-item"
        :class="{'menu-item-active': activeName === route.name}"
      >
        <router-link
          :to="route.path"
          class="menu-item-link"
          :data-activeindex="index"
          :data-activename="route.name"
        >
          <span v-if="route.meta.icon">
            <img class="icon" v-if="activeName === route.name" :src="getIcon(route.meta.icon, true)" alt=""/>
            <img class="icon" v-else :src="getIcon(route.meta.icon, false)" alt=""/>
          </span>
          <span class="FirTitle">
            {{ route.meta.title }}
          </span>
          <div :class="{'triangle': activeName === route.name}"></div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  watch: {
    $route (to, from) {
      this.judgeRoute()
    },
    activeIndex: {
      handler (val) {
        this.$emit('tabChange', val)
      },
      immediate: true
    },
    routes: {
      handler (val) {
        console.log(val)
      },
      deep: true
    }
  },
  data () {
    return {
      roleId: '',
      activeIndex: 0,
      activeName: '',
      routes: []
    }
  },
  mounted () {
    this.roleId = this.$store.getters.roleId
    this.routes = [...this.$store.getters.routes]
    this.routes = this.routes.filter(item => item.meta && !item.meta.hidden)
    this.judgeRoute()
  },
  methods: {
    tab (e) {
      if (e.target.nodeName === 'A') {
        this.activeIndex = e.target.dataset.activeindex
        this.activeName = e.target.dataset.activename
      }
    },
    judgeRoute () {
      this.activeName = this.$route.path.split('/')[1]
      this.routes.map((item, index) => {
        if (item.name === this.activeName) {
          this.activeIndex = index
        }
      })
    },
    getIcon (icon, isActive) {
      if (isActive) {
        try {
          return require('../../assets/img/icon/' + icon + '_active.png')
        } catch (e) {
          return require('../../assets/img/icon/info_active.png')
        }
      } else {
        try {
          return require('../../assets/img/icon/' + icon + '.png')
        } catch (e) {
          return require('../../assets/img/icon/info.png')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sysTitle {
    height:70px;
    color:#fff;
    font-size:14px;
    padding:20px 15px
  }
  .marg {
    margin-top:5px
  }
  .sidemenu {
    position: fixed;
    width:120px;
    height:100vh;
    overflow-y:hidden;
    background:rgba(40,44,60,1);
  }
  .menu-item {
    height:50px;
    line-height:50px;
    color:#fff;
    cursor: pointer;
    text-align: center;
    .icon{
      vertical-align: text-bottom;
      width: 16px;
      height: 16px;
    }
    &-link{
      width: 120px;
      height:50px;
      line-height:50px;
      display:inline-block;
      font-size:14px;
    };
    &-active{
      background:rgba(73,117,219,1);
    }
  }
  .triangle{
    width: 0;
    height: 0;
    float:right;
    position: relative;
    right:0;
    top:15px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
    }
    .FirTitle {
      display:inline-block;
      width:50px;
      text-align:left;
      margin-left:10px;
      vertical-align: baseline;
    }
</style>
